import { auth } from '@/firebase';
import { useNavigate } from 'react-router-dom';

export default function UnregisteredView() {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await auth.signOut();
            navigate('/');
            window.location.reload(); // Reload to clear any state
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className="ri-error-warning-line text-red-500 text-3xl"></i>
                </div>
                <h2 className="text-xl font-bold text-gray-800 mb-2">登録情報がありません</h2>
                <p className="text-gray-600 mb-8">
                    この電話番号は登録されていません。<br />
                    事務局に確認してください。
                </p>
                <button
                    onClick={handleLogout}
                    className="w-full bg-gray-800 text-white py-3 rounded-lg font-medium hover:bg-gray-900 transition-colors cursor-pointer"
                >
                    ログアウト
                </button>
            </div>
        </div>
    );
}
